export default "__VITE_ASSET__w1k_w5SA__"